<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	//Stores
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';
	import SettingGuide from '../../../SettingGuide.svelte';

	export let device;
	export let title = '';
	export let deferSave = false;
	export let value: boolean | undefined;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);

	let invert = settings[`input:${device.channel}`].invert;
	let cache = invert;

	$: displayed = deferSave && typeof value === 'boolean' ? value : invert;

	const sentRequests = async () => {
		if (deferSave) {
			value = !displayed;
			return;
		}
		const newValueInvert = !invert;
		if (cache === newValueInvert) return;
		const params = { id: device.channel, config: { invert: newValueInvert } };

		const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', params);

		if (res.isok) {
			invert = newValueInvert;
			settings[`input:${device.channel}`].invert = invert;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast'),
			});
			cache = invert;
		} else {
			toast.open({ type: 'danger', title: $format('invert_input_err_toast') });
			invert = cache;
		}
	};
</script>

<SettingGuide
	{title}
	text={$format('settings_guide_invert_switch', {
		default:
			'Swap which switch position is on and which is off, so the wall switch matches how it is wired.',
	})}
/>

<Toggle checked={displayed} size="m" on:click={sentRequests} id="toggle-z32r8ao">
	{$format('settings_toggle_invert', {
		default: 'Invert',
	})}
</Toggle>
